var spots = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/spots_CD25_1b_8.jpg';
var spotsDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/1_spotsDetail.jpg';
var surrender = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/surrender_Em201604_Surrender_painting_v5.jpg';
var surrenderDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/2_surrenderDetail.jpg';
var bridge = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/bridge_CD25_2c_5.jpg';
var bridgeDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/3_bridgeDetail.jpg';
var lunge = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/lunge_CD26_10.jpg';
var lungeDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/4a_lungeDetail.jpg';
var lungeDetail2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/4b_lungeDetail.jpg';
var tethered = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/tethered_unknown_Tethered.jpg';
var tetheredDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/5_tetheredDetail.jpg';
var tilt = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/tilt_Em201604_Tilt_painting_v1.jpg';
var tiltDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/7_tiltDetail.jpg';
var crescent = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/crescent_CD26_03_0.jpg';
var crescentDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/8a_crescentDetail.jpg';
var crescentDetail2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/8b_crescentDetail.jpg';
var suspension = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/suspension_Em201604_Suspension_painting_v1.jpg';
var suspensionDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/6a_suspensionDetail.jpg';
var suspensionDetail2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-io/6b_suspensionDetail.jpg';

export const allImagesDesktopOrderIO = [
    [/*COLUMN 1*/
        [
            {
                name: spots,
                artistName: "Lorraine Shemesh",
                title: "Spots",
                year: "2012",
                dimensions: "65 x 63 in., o/c",
                link: "io1",
                privateCollection: "Private Collection"
            },
            {
                name: spotsDetail1,
                artistName: "Lorraine Shemesh",
                title: "Spots - detail",
                year: "2012",
                dimensions: "65 x 63 in., o/c",
                link: "io9",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: surrender,
                artistName: "Lorraine Shemesh",
                title: "Surrender",
                year: "2015",
                dimensions: "58 x 70 in., o/c",
                link: "io2",
                privateCollection: ""
            },
            {
                name: surrenderDetail1,
                artistName: "Lorraine Shemesh",
                title: "Surrender - detail",
                year: "2015",
                dimensions: "58 x 70 in., o/c",
                link: "io10",
                privateCollection: ""
            }
        ],
        [
            {
                name: bridge,
                artistName: "Lorraine Shemesh",
                title: "Bridge",
                year: "2012",
                dimensions: "47 1/2 x 79 in., o/c",
                link: "io3",
                privateCollection: "Private Collection"
            },
            {
                name: bridgeDetail1,
                artistName: "Lorraine Shemesh",
                title: "Bridge - detail",
                year: "2012",
                dimensions: "47 1/2 x 79 in., o/c",
                link: "io11",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: lunge,
                artistName: "Lorraine Shemesh",
                title: "Lunge",
                year: "2013",
                dimensions: "67 1/2 x 53 1/2 in., o/c",
                link: "io4",
                privateCollection: ""
            },
            {
                name: lungeDetail1,
                artistName: "Lorraine Shemesh",
                title: "Lunge - detail",
                year: "2013",
                dimensions: "67 1/2 x 53 1/2 in., o/c",
                link: "io12",
                privateCollection: ""
            },
            {
                name: lungeDetail2,
                artistName: "Lorraine Shemesh",
                title: "Lunge - detail",
                year: "2013",
                dimensions: "67 1/2 x 53 1/2 in., o/c",
                link: "io13",
                privateCollection: ""
            }
        ],
        [
            {
                name: tethered,
                artistName: "Lorraine Shemesh",
                title: "Tethered",
                year: "2014",
                dimensions: "58 x 64 1/2 in., o/c",
                link: "io5",
                privateCollection: ""
            },
            {
                name: tetheredDetail1,
                artistName: "Lorraine Shemesh",
                title: "Tethered - detail",
                year: "2014",
                dimensions: "58 x 64 1/2 in., o/c",
                link: "io14",
                privateCollection: ""
            }
        ],
        [
            {
                name: suspension,
                artistName: "Lorraine Shemesh",
                title: "Suspension",
                year: "2013",
                dimensions: "70 1/4 x 56 1/4 in., o/c",
                link: "io6",
                privateCollection: "Private Collection"
            },
            {
                name: suspensionDetail1,
                artistName: "Lorraine Shemesh",
                title: "Suspension - detail",
                year: "2013",
                dimensions: "70 1/4 x 56 1/4 in., o/c",
                link: "io15",
                privateCollection: "Private Collection"
            },
            {
                name: suspensionDetail2,
                artistName: "Lorraine Shemesh",
                title: "Suspension - detail",
                year: "2013",
                dimensions: "70 1/4 x 56 1/4 in., o/c",
                link: "io16",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: tilt,
                artistName: "Lorraine Shemesh",
                title: "Tilt",
                year: "2015",
                dimensions: "59 1/4 x 63 1/4 in., o/c",
                link: "io7",
                privateCollection: ""
            },
            {
                name: tiltDetail1,
                artistName: "Lorraine Shemesh",
                title: "Tilt - detail",
                year: "2015",
                dimensions: "59 1/4 x 63 1/4 in., o/c",
                link: "io17",
                privateCollection: ""
            }
        ],
        [
            {
                name: crescent,
                artistName: "Lorraine Shemesh",
                title: "Crescent",
                year: "2013",
                dimensions: "75 x 48 3/4 in., o/c",
                link: "io8",
                privateCollection: "Permanent Collection of the Butler Institute of American Art"
            },
            {
                name: crescentDetail1,
                artistName: "Lorraine Shemesh",
                title: "Crescent - detail",
                year: "2013",
                dimensions: "75 x 48 3/4 in., o/c",
                link: "io18",
                privateCollection: "Permanent Collection of the Butler Institute of American Art"
            },
            {
                name: crescentDetail2,
                artistName: "Lorraine Shemesh",
                title: "Crescent - detail",
                year: "2013",
                dimensions: "75 x 48 3/4 in., o/c",
                link: "io19",
                privateCollection: "Permanent Collection of the Butler Institute of American Art"
            }
        ]
    ]          
]

export const allImagesMobileOrderIO = [
    [{
        name: spots,
        artistName: "Lorraine Shemesh",
        title: "Spots",
        year: "2012",
        dimensions: "65 x 63 in., o/c",
        link: "io1",
        privateCollection: "Private Collection"
    },
    {
        name: spotsDetail1,
        artistName: "Lorraine Shemesh",
        title: "Spots - detail",
        year: "2012",
        dimensions: "65 x 63 in., o/c",
        link: "io9",
        privateCollection: "Private Collection"
    },
    {
        name: surrender,
        artistName: "Lorraine Shemesh",
        title: "Surrender",
        year: "2015",
        dimensions: "58 x 70 in., o/c",
        link: "io2",
        privateCollection: ""
    },
    {
        name: surrenderDetail1,
        artistName: "Lorraine Shemesh",
        title: "Surrender - detail",
        year: "2015",
        dimensions: "58 x 70 in., o/c",
        link: "io10",
        privateCollection: ""
    },
    {
        name: bridge,
        artistName: "Lorraine Shemesh",
        title: "Bridge",
        year: "2012",
        dimensions: "47 1/2 x 79 in., o/c",
        link: "io3",
        privateCollection: "Private Collection"
    },
    {
        name: bridgeDetail1,
        artistName: "Lorraine Shemesh",
        title: "Bridge - detail",
        year: "2012",
        dimensions: "47 1/2 x 79 in., o/c",
        link: "io11",
        privateCollection: "Private Collection"
    },
    {
        name: lunge,
        artistName: "Lorraine Shemesh",
        title: "Lunge",
        year: "2013",
        dimensions: "67 1/2 x 53 1/2 in., o/c",
        link: "io4",
        privateCollection: ""
    },
    {
        name: lungeDetail1,
        artistName: "Lorraine Shemesh",
        title: "Lunge - detail",
        year: "2013",
        dimensions: "67 1/2 x 53 1/2 in., o/c",
        link: "io12",
        privateCollection: ""
    },
    {
        name: lungeDetail2,
        artistName: "Lorraine Shemesh",
        title: "Lunge - detail",
        year: "2013",
        dimensions: "67 1/2 x 53 1/2 in., o/c",
        link: "io13",
        privateCollection: ""
    },
    {
        name: tethered,
        artistName: "Lorraine Shemesh",
        title: "Tethered",
        year: "2014",
        dimensions: "58 x 64 1/2 in., o/c",
        link: "io5",
        privateCollection: ""
    },
    {
        name: tetheredDetail1,
        artistName: "Lorraine Shemesh",
        title: "Tethered - detail",
        year: "2014",
        dimensions: "58 x 64 1/2 in., o/c",
        link: "io14",
        privateCollection: ""
    },
    {
        name: suspension,
        artistName: "Lorraine Shemesh",
        title: "Suspension",
        year: "2013",
        dimensions: "70 1/4 x 56 1/4 in., o/c",
        link: "io6",
        privateCollection: "Private Collection"
    },
    {
        name: suspensionDetail1,
        artistName: "Lorraine Shemesh",
        title: "Suspension - detail",
        year: "2013",
        dimensions: "70 1/4 x 56 1/4 in., o/c",
        link: "io15",
        privateCollection: "Private Collection"
    },
    {
        name: suspensionDetail2,
        artistName: "Lorraine Shemesh",
        title: "Suspension - detail",
        year: "2013",
        dimensions: "70 1/4 x 56 1/4 in., o/c",
        link: "io16",
        privateCollection: "Private Collection"
    },
    {
        name: tilt,
        artistName: "Lorraine Shemesh",
        title: "Tilt",
        year: "2015",
        dimensions: "59 1/4 x 63 1/4 in., o/c",
        link: "io7",
        privateCollection: ""
    },
    {
        name: tiltDetail1,
        artistName: "Lorraine Shemesh",
        title: "Tilt - detail",
        year: "2015",
        dimensions: "59 1/4 x 63 1/4 in., o/c",
        link: "io17",
        privateCollection: ""
    },
    {
        name: crescent,
        artistName: "Lorraine Shemesh",
        title: "Crescent",
        year: "2013",
        dimensions: "75 x 48 3/4 in., o/c",
        link: "io8",
        privateCollection: "Permanent Collection of the Butler Institute of American Art"
    },
    {
        name: crescentDetail1,
        artistName: "Lorraine Shemesh",
        title: "Crescent - detail",
        year: "2013",
        dimensions: "75 x 48 3/4 in., o/c",
        link: "io18",
        privateCollection: "Permanent Collection of the Butler Institute of American Art"
    },
    {
        name: crescentDetail2,
        artistName: "Lorraine Shemesh",
        title: "Crescent - detail",
        year: "2013",
        dimensions: "75 x 48 3/4 in., o/c",
        link: "io19",
        privateCollection: "Permanent Collection of the Butler Institute of American Art"
    }]      
]